<template>
  <v-btn class="btn--kakao" depressed block :height="height" @click="kakao" :class="[...classes]">
    카카오 로그인
  </v-btn>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    classes: {
      type: Array,
      default() {
        return ['mt-4', 'font--m-3', 'rounded-3']
      },
    },
    height: {
      type: String,
      default: '52',
    },
  },
  methods: {
    ...mapActions('auth', ['signinKakao']),

    async kakao() {
      await this.signinKakao({
        redirectUri: this.$cookies.get('redirectUri'),
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep.btn--kakao {
  color: #252525 !important;
  background-color: #fee500 !important;

  span.v-btn__content:before {
    display: inline-block;
    content: '';
    background: url('../../assets/images/icons/kakao_symbol.svg') no-repeat 50%;
    background-size: contain;
    margin-right: 4px;
    width: 22px;
    height: 22px;
    vertical-align: middle;
  }
}
</style>
